import { useMemo } from 'react';
import { useAuth } from "auth/useAuth";

/**
 * Hook to get the Cognito groups from the authenticated user's ID token.
 * Groups are included in the token claim "cognito:groups".
 * @returns {Object} { groups, isAssociate, isAdmin }
 */
export const useUserGroups = () => {
  const auth = useAuth();

  const groups = useMemo(() => {
    if (!auth.isAuthenticated || !auth.user) return [];

    // react-oidc-context parses the ID token claims into auth.user.profile
    // Cognito groups appear under "cognito:groups" as an array
    const tokenGroups = auth.user.profile?.["cognito:groups"];

    if (Array.isArray(tokenGroups)) return tokenGroups;
    if (typeof tokenGroups === 'string') return [tokenGroups];
    return [];
  }, [auth.isAuthenticated, auth.user]);

  return {
    groups,
    isAssociate: groups.includes('associates'),
    isAdmin: groups.includes('admin'),
  };
};
